import { interval, BehaviorSubject } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';
import { isPlainObject } from 'is-plain-object';

import request from '@utils/axiosWrapper';

let currentLoopInterval = 60;

const pollingIntervalInSeconds$ = new BehaviorSubject(currentLoopInterval);

/** 反扒数据定时上报 */
const init = () => {
    pollingIntervalInSeconds$
        .pipe(
            switchMap(pollingInterval => interval(pollingInterval * 1000)),
            startWith(0),
        )
        .subscribe(() => {
            request.postAsFormSubmit<{ loopInterval: number }>('/v2/common/pcInfo/w/report').then(
                res => {
                    if (res.loopInterval && res.loopInterval !== currentLoopInterval) {
                        currentLoopInterval = res.loopInterval;
                        pollingIntervalInSeconds$.next(currentLoopInterval);
                    }
                },
                error => {
                    if (!isPlainObject(error)) {
                        throw Error(error.message);
                    }
                },
            );
        });
};

export default { init };
